module.exports = __webpack_public_path__ + "images/category_lp/watch/omega_samples/sec02_sp_240da9bb151f04cad489b358d8d14ad4.jpg";